/** Persistent, independent category preferences. Safe for SSR and node tests. */
export type SoundCategory="sfx"|"music";
export type AudioSettings=Readonly<Record<SoundCategory,boolean>>;
export const AUDIO_SETTINGS_KEY="echo-engine-audio";
export const AUDIO_SETTINGS_EVENT="echo-engine:audio-change";
export const DEFAULT_AUDIO_SETTINGS:AudioSettings=Object.freeze({sfx:true,music:true});
let current:AudioSettings|null=null;
export function parseAudioSettings(raw:string|null):AudioSettings{
  try{
    const value=JSON.parse(raw??"null");
    return Object.freeze({sfx:typeof value?.sfx==="boolean"?value.sfx:true,
      music:typeof value?.music==="boolean"?value.music:true});
  }catch{return DEFAULT_AUDIO_SETTINGS;}
}
export function getAudioSettings():AudioSettings{
  if(current)return current;
  try{current=typeof window==="undefined"?DEFAULT_AUDIO_SETTINGS:parseAudioSettings(window.localStorage.getItem(AUDIO_SETTINGS_KEY));}
  catch{current=DEFAULT_AUDIO_SETTINGS;}
  return current;
}
export const getServerAudioSettings=()=>DEFAULT_AUDIO_SETTINGS;
export function setAudioEnabled(category:SoundCategory,enabled:boolean){
  current=Object.freeze({...getAudioSettings(),[category]:enabled});
  if(typeof window==="undefined")return;
  try{window.localStorage.setItem(AUDIO_SETTINGS_KEY,JSON.stringify(current));}catch{/* Session choice still applies. */}
  window.dispatchEvent(new CustomEvent(AUDIO_SETTINGS_EVENT,{detail:current}));
}
export function subscribeAudioSettings(change:()=>void):()=>void{
  if(typeof window==="undefined")return()=>{};
  const local=(event:Event)=>{current=parseAudioSettings(JSON.stringify((event as CustomEvent).detail));change();};
  const storage=(event:StorageEvent)=>{
    if(event.key!==AUDIO_SETTINGS_KEY&&event.key!==null)return;
    current=parseAudioSettings(event.key===null?null:event.newValue);change();
  };
  window.addEventListener(AUDIO_SETTINGS_EVENT,local);window.addEventListener("storage",storage);
  return()=>{window.removeEventListener(AUDIO_SETTINGS_EVENT,local);window.removeEventListener("storage",storage);};
}
export function resetAudioSettingsCache(){current=null;}
